import AdRingierWidget from '@widgets/AdRingier'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'

const widget = {
  kind: ['ad-teads'],
  component: AdRingierWidget.component,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
